import { keyframes } from 'styled-components';

export const leftToRight = keyframes`
  0% {
    width: 0;
  }

  100% {
    width: 100%;
  }
`;

export const fadeOut = keyframes`
  0% {
    opacity: 1;
  }

  99% {
    opacity: 0;
  }

  100% {
    opacity: 0;
    visibility: hidden;
  }
`;

export const fadeIn = keyframes`
  0% {
    visibility: hidden;
    opacity: 0;
  }

  1% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

export const open = keyframes`
  0% {
    max-height: 0;
    visibility: hidden;
  }

  99% {
    max-height: none;
  }

  100% {
    max-height: none;
  }
`;

export const close = keyframes`
  0% {
    max-height: none;
  }

  99% {
    max-height: 0;
  }

  100% {
    max-height: 0;
    visibility: hidden;
  }
`;

export default {
  leftToRight,
  fadeOut,
  fadeIn,
  open,
  close,
};
